import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { UserSessionContext } from 'components/UserSession';

import UserAvatar from 'components/UserAvatar';
import IconLogout from '../icons/Logout';

const UserAccountContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 6px;
  max-width: 200px;
`;

const UserAccountButton = withStyles(() => ({
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'none',
  },
}))(Button);

const UserNameContainer = styled.span`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: #484848;
  margin-right: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledLogoutBtn = styled.div`
  color: #484848;
  text-decoration: none;
  display: flex;
  align-items: center;
`;

const LogoutText = styled.span`
  margin-left: 10px;
`;

const UserAccountView = () => {
  const { userSession, setUserSession } = useContext(UserSessionContext);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onLogoutClick = () => {
    setUserSession({});
  };

  return (
    <UserAccountContainer>
      <UserAccountButton onClick={handleClick}>
        <UserNameContainer>
          {`Hi, ${userSession.firstName}`}
        </UserNameContainer>
        <UserAvatar name={userSession.firstName} />
      </UserAccountButton>
      <Menu
        id="user-settings-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem onClick={onLogoutClick}>
          <StyledLogoutBtn>
            <IconLogout color="#484848" />
            <LogoutText>
              Logout
            </LogoutText>
          </StyledLogoutBtn>
        </MenuItem>
      </Menu>
    </UserAccountContainer>
  );
};

export default UserAccountView;
